declare global {
  interface Window {
    dataLayer: any;
  }
}

const trackApplyCouponValidationInPL = (data, timings, isAutoApply = false) => {
  if (!data?.modifiers?.coupon) {
    // there is no coupon associated with the cart
    return
  }

  const coupon = data?.modifiers?.coupon
  const logData = {
    pageType: 'product-listing',
    triggeredBy: 'add-to-cart',
    hasDiscount: false,
    timings,
    isAutoApply,
  } as {
    pageType: string;
    event: string;
    triggeredBy: string;
    hasDiscount: boolean;
    timings: any;
    isAutoApply: boolean;
    coupon: any;
  }

  let discountApplied = []

  if (coupon && coupon.discounts && coupon.discounts.length) {
    discountApplied = coupon?.discounts.filter(discount => discount?.applied)
  }

  const hasDiscount = discountApplied && discountApplied.length > 0
  logData.hasDiscount = hasDiscount

  if (coupon && hasDiscount) {
    logData.event = 'apply-coupon-validation-successful'
  } else {
    logData.event = 'apply-coupon-validation-failed'
  }
  logData.coupon = { ...coupon }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackApplyCouponValidationInPL
